import CallApp from '@ks/call-app';

interface CallOption {
    onelink: string
    protocol?: string
    host?: string
    path?: string
    param?: Record<string, any>
    timeout?: number
}

// path: 不加协议
export function callApp(option: CallOption, callback?: Function|null) {
    const { protocol = 'ikwai', host, onelink, path, param, timeout = 2500 } = option;

    const callApp = new CallApp({
        scheme: {
            protocol,
            host,
        },
        appstore: onelink,
        fallback: onelink,
        timeout,
    });

    const opt: Record<string, any> = {
        path,
        param,
    };

    if (callback) opt.callback = callback;

    callApp.open(opt);
}

export const getOneLinkUrlNew = (onelink: string, callAppPath: string|undefined, protocol: string = 'ikwai') => {

    let oneLink = onelink;
  
    if (callAppPath) {
        const deep_link_value = encodeURIComponent(`${protocol}://${callAppPath}`);
        if (oneLink.indexOf('deep_link_value') === -1) oneLink = `${oneLink}&deep_link_value=${deep_link_value}`;
        oneLink = `${oneLink}&af_dp=${deep_link_value}&af_force_deeplink=true`;
    }
  
    return oneLink;
};

export function callAppNew(option: CallOption, callback?: Function|null) {
    const { protocol = 'ikwai', host, onelink, path, param, timeout = 2500 } = option;
    console.log('callappNew', option);
    window.location.href = getOneLinkUrlNew(onelink, path, protocol);
}
